const mountComplianceRows = (questionnaires) => {
  return questionnaires?.map((questionnaire) => ({
    name: questionnaire.name,
    value: formatPercentage(questionnaire.complianceGap),
    percentage: formatPercentage(questionnaire.complianceGap),
    status: questionnaire.status,
  }))
}

const formatPercentage = (compliance) => {
  return parseFloat(compliance).toFixed(0)
}

export default mountComplianceRows
